export default __webpack_public_path__ + "static/media/Senior.93aaf4c6.svg";